import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

/** Pages for super admins and partner admins; everyone else goes back to `/`. */
export const Route = createFileRoute('/_app/_partners')({
  beforeLoad: ({ context }) => {
    if (
      context.role.kind !== 'superAdmin' &&
      context.role.kind !== 'partnerAdmin'
    ) {
      throw redirect({ to: '/' })
    }
  },
  component: () => <Outlet />,
})
